export default {
  share: {
    title: '连接·生活',
    openButton: '打开MyLink查看更多',
    download: '下载MyLink APP',
    open: '打开',
    wxGuide: {
      ios: '请点击右上角的"..."按钮,选择"在Safari中打开”',
      android: '请点击右上角的"..."按钮,选择”在浏览器中打开”'
    }
  },
  netEttor: {
    cancel: '取消',
    oterError: '其它错误类',
    checkNetwork: '请检查是否已连接到网络',
    backHome: '返回首页'
  },
  policy: [
    '私隐政策声明',
    '总览',
    '本声明是由中国移动香港有限公司（「我们」或「中移香港」）根据香港特别行政区法例第486章《个人资料（私隐）条例》（「条例」）而作出。',
    '本声明说明我们在收集、使用、转移、和查阅顾客个人资料的政策和做法。本声明内「个人资料」一词含有条例所解释的意义。',
    '为何我们收集阁下资料？ ',
    '我们不时向阁下收集个人资料，以便向阁下提供我们的产品或服务。所收集资料包括但不限于：',
    ['阁下的姓名；',
      '安装服务的地址、通讯地址及/或寄发账单的地址；',
      '账户详情、包括账户号码、服务号码或使用者账号；',
      '身份证号码或护照号码或港澳居民来往内地通行证号码；',
      '付款详情，包括信用卡及银行资料；及',
      '联络详情，包括联络人姓名、电话号码、传真号码或电邮地址。'
    ],
    '阁下没有义务向我们提供阁下的个人资料，但如阁下不提供个人资料，我们可能无法向阁下提供所需的产品和服务。',
    '为了让阁下有更佳的客户体验，我们可能邀请阁下自愿提供年龄、出生日期、性别、教育程度及职业、薪金水平、兴趣爱好及公余活动，其他有关并已申请的产品及服务，家庭及家居统计等资料。我们会在有关表格或申请表上指出所需的个人资料是否必须提供。',
    '此外，阁下的线上资料可能会以总计及不记名方式被间接收集。',
    '倘若阁下年龄未满13岁，阁下必须征得阁下家长或监护人的同意，方可向我们提供任何个人资料。',
    '阁下资料的可能用途',
    '阁下的个人资料可能被使用于以下各项之目的：',
    ['核实阁下身份；',
      '处理阁下选购我们的产品和服务的申请；',
      '向阁下提供产品和服务；',
      '规管及执行阁下所选购的长期客户优惠计划；',
      '管理向阁下提供的产品和服务包括续约事宜；',
      '通知阁下有关我们提供的产品和服务的最新资讯；',
      '根据本声明第10段列明的，在取得阁下的同意下作推广和宣传之用；',
      '与就其他目的而从其他来源包括第三方所收集的资料作核对，以提升阁下的客户体验；',
      '内部统计及分析用途；',
      '根据阁下的需要，为阁下设计及改善产品和服务；',
      '处理阁下的查询、投诉和回馈；',
      '日常业务监察及管理；',
      '透过电邮、电话、信函或其他途径联络阁下；',
      '记账；',
      '处理付款提示；',
      '收取阁下账户未付的款项(包括聘用追收债务代理人和民事诉讼)及信贷调查；',
      '寻求法律咨询和在法律程序中提出法律索赔或辩护；',
      '预防和调查欺诈及其他犯罪活动；',
      '根据任何地区的法例、规则、法庭命令而作出或可作出的披露或任何政府、监管机关或执法机构要求的披露；',
      '与上述任何用途有关及相关或其他阁下不时同意的用途之任何其他用途。'
    ],
    '个人资料的披露和转移 ',
    '我们可能会向以下各方转移、披露或共享享阁下的个人资料（不论是在香港境内或境外）以达到上述第7段的目的，阁下的个人资料可能被转移至香港境内或境外。',
    ['任何附属公司、控股公司、关联公司，或由我们所持有或与我们同属一家控制公司的公司或联营公司；',
      '任何代表我们或与我们联营的个人或公司，以达到提供此等资料之目的，或直接与其有关之目的；',
      '有责任为我们对上述资料保密的任何其他人士或公司，而该人士或公司有法定的权利取用该资料；',
      '我们的经销商、代理、承办商、供货商、及其他电讯、资讯服务商及内容供应商；我们的专业顾问，包括会计师、审计师及律师；',
      '政府和监管机关、执法机构和法律规定或授权的其他组织；',
      '任何所需的金融机构、收费或信用卡发行公司、信贷提供者、信贷资料或调查机构，或代收欠款的代理人、证劵代理，以便设立和支持任何所需求服务的支付；',
      '阁下的授权代表或法律顾问（在阁下要求下）；',
      '电讯网络运营商；',
      '第三方奖赏和长期客户优惠计划供应商；',
      '管理我们业务及企业策略的组织，包括为该等目的参与转让/出售我们全部或部份的资产或业务（包括账户和应收账款）以及参 与管理我们的企业风险和资金筹集功能（例如证券化）的组织；以及',
      '有关我们全部或部份运营业务的任何潜在或实际参与者、承让人或受让方。'
    ],
    '个人资料的保安和保存',
    '我们一贯致力确保阁下的个人资料受安全保护，不会未经授权或意外地被他人取得、处理、清除或作其他用途。为致力保障阁下个人资料安全，我们在设施、电子系统及管理方面实施适当措施，以保障阁下的个人资料安全。除非个人资料基于合约或适用法例而另作保存，否则我们只会在就原来收集目的(或其直接相关目的)而言必须的期间内保存个人资料。',
    '个人资料用于直接促销用途',
    '根据条例及在阁下同意的情况下，我们会将包括但不限于本声明第3至5段提及的个人资料作直接促销的用途，包括发送任何与我们或我们的商业伙伴的产品和服务有关的信息、长期客户优惠计划、活动（包括与第三方合作的活动）、最新情报、比赛、抽奖等。上述资讯可能包括不同的推广资料，包括但不限于流动装置及配件、电讯网络服务如电视、流动话音、短讯及数码通讯、IDD/国际漫游、互联网连接、流动应用程序、娱乐及互联网数据通讯、其他增值服务、以及电脑周边产品、配件和软件(包括笔记型电脑、手提电话、键盘、保安装置及流动应用程式)、秘书服务、个人助理服务和资讯服务、游戏、运动、音乐、美容产品、电子产品、科技、电子商务、手机付款、旅游、银行、投资、娱乐、交通、家居、时尚、餐饮、烟酒、保险、教育、健康及保健、社交网络、慈善活动、媒体及高端消费类产品及服务。我们可能透过信函、电话、电邮、传真或其他途径传送上述资讯给阁下。',
    '除非阁下表示同意或不反对，否则我们不能使用阁下的个人资料作直接促销的目的。倘若阁下希望停止接收我们直接促销的资讯，阁下可随时依本声明第14条列明的方法致函我们。所有此等要求，应明确列出有关的个人资料和联络详情以确认身份。',
    'Cookies的使用和位置资料',
    '若阁下使用我们的任何网站，我们可能使用cookie文件储存及跟踪与阁下及阁下的偏好有关的资料。Cookie是由我们的网站传输至阁下设备上的小型文本文件。透过Cookies的使用，我们能够更好地服务阁下，及/或在一个或多个浏览时段中跨越多个页面地保持阁下的资料。大多数网络浏览器均自动接受Cookies，但是若阁下选择，阁下可更改阁下的浏览器选项以禁用Cookies。Cookies储存与阁下及阁下的偏好有关的资料。例如，若阁下查询价格及供应情况，网站可能会建立含有阁下所输入的资料的Cookie。 Cookie亦可以只储存阁下在网站中所浏览的网页记录，以帮助网站为阁下定制阁下于下一次浏览时的画面。只有阁下在使用网站时提供的资料或所作出的选择能够存储于cookie中。例如，除非阁下选择输入电邮地址，否则网站无法确定阁下的电邮地址。允许网站建立Cookie并不会令该网站或任何其他网站能够存取阁下的设备的其余部分，而且只有建立Cookie的网站能够阅读该Cookie。',
    '我们可将阁下的位置资料用于跟踪阁下的活动模式及偏好，以改进阁下获得的服务水平。阁下的位置资料可能与我们从第三方接收的其他资料合并， 以便向阁下提供更佳的服务。在阁下同意接受直接促销的情况下，我们可就上述第10条的直接促销类别向阁下提供针对性的广告、内容、交易及优惠。',
    '查阅或更正个人资料',
    '阁下有查阅其个人资料的权利。若阁下欲取得该等资料的副本或认为我们收集及保留了不准确的个人资料，请致函下列地址： ',
    '资料保护主任中国移动香港有限公司香港新界葵涌葵昌路51号九龙贸易中心1座20楼',
    '有关查阅或更正个人资料的要求或对我们在收集顾客个人资料的政策和做法的查询，可致函我们上述地址。根据私隐条例规定，我们有权为受理资料查核要求而收取合理费用。',
    '其他',
    '我们保留不时修改本声明的权利。',
    '本声明的中文版和英文版如有抵触，概以英文版为准。',
    '版本: E201609a'
  ]
}



// WEBPACK FOOTER //
// ./src/locale/global/zh-cn.js